<template lang="pug">
  include /mixins
  div
    +b.ds-panel.--space_2xl.--space_3xl-xl
      +e.element.--offset_bottom
        +b.ds-panel.--space_xl.--space_2xl-xl
          +e.element.--offset_bottom
            +b.P.ds-caption.--size_sm.--size_md-xl.--semibold {{ _("Косметолог, выполнявший процедуру") }}
        +b.g-row.--space_2xl.--appearance_spaced
          +b.g-cell.g-cols--12
            d-control-input(
              :rules="{ required: true }",
              :input-label="labels.doctor_last_name"
              v-model="form.doctor_last_name"
              name="doctor_last_name",
            )
          +b.g-cell.g-cols--12
            d-control-input(
              :rules="{ required: true }",
              :input-label="labels.doctor_first_name"
              v-model="form.doctor_first_name"
              name="doctor_first_name",
            )
    +b.ds-panel.--space_xl.--space_2xl-xl
      +e.element.--offset_bottom
        +b.P.ds-caption.--size_sm.--size_md-xl.--semibold {{ _("Развернутое описание процедуры") }}
    d-control-textarea.is-textarea(
      :input-label='labels.procedure_description'
      :rules="'required|min:5'",
      rows='6'
      v-model='form.procedure_description',
      name='procedure_description',
      ref='procedure_description'
      error-classes='error-label--top'
    )
</template>

<script>
export default {
  props: ['form'],

  data() {
    return {
      labels: {
        procedure_description: this._('Описание процедуры'),
        doctor_last_name: this._('Фамилия косметолога'),
        doctor_first_name: this._('Имя косметолога'),
      },
    }
  },
}
</script>
